import styled from "styled-components"
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import DefaultLayout from "../components/molecules/common/DefaultLayout"
import EmailAuthStep from "../components/molecules/auth/EmailAuthStep";
import TermsAgreeStep from "../components/molecules/auth/TermsAgreeStep";
import UserInfoStep from "../components/molecules/auth/UserInfoStep";
import { useModal } from "../hooks/useModal";
import ExitModal from "../components/molecules/common/ExitModal";

const Signup = () => {
  const steps = ['email-verification', 'terms', 'user-info'];
  const { step } = useParams();
  const navigate = useNavigate();
  const { open, close, isOpen, modalType } = useModal();

  const handleExit = () => {  
    sessionStorage.removeItem('emailVerified');
    sessionStorage.removeItem('termsAgreed');
    sessionStorage.removeItem('terms');
    sessionStorage.removeItem('userInfo');
    close();
    navigate('/login');
  }

  const handleNext = (currentStep) => {
    if (currentStep === 'email-verification') {
      navigate('/signup/terms', { replace: true });
    } else if (currentStep === 'terms') {
      navigate('/signup/user-info');
    }
  };

  const handleBack = () => {
    if (step === 'email-verification') {
      navigate('/login');
    } else if (step === 'terms') {
      open("exit")
    } else {
      // 그 외 단계는 그냥 이전 단계로 이동
      const currentIndex = steps.indexOf(step);
      if (currentIndex > 0) navigate(`/signup/${steps[currentIndex - 1]}`);
    }
  };

  // 입력 데이터 전체 상태
  const [emailAuth, setEmailAuth] = useState({email: '', code: ''})
  const [agreedTerms, setAgreedTerms] = useState(() => 
    new Set(JSON.parse(sessionStorage.getItem('terms')) || [])
  )

  const [userInfo, setUserInfo] = useState(() => {
    const saved = JSON.parse(sessionStorage.getItem('userInfo'));
    return {
      name: saved?.name || '',
      email: saved?.email || '',
      password: '', // 비밀번호는 보안상 항상 빈 문자열로 초기화
      phoneNumber: saved?.phoneNumber || ''
    };
  });

  // sessionStorage에 저장
  useEffect(() => {
    sessionStorage.setItem('terms', JSON.stringify([...agreedTerms]))
    const { password, ...userInfoWithoutPassword } = userInfo;
    sessionStorage.setItem('userInfo', JSON.stringify(userInfoWithoutPassword))
  }, [agreedTerms, userInfo])

  // url 우회 방지
  useEffect(() => {
    if (step === 'terms') {
      const emailVerified = sessionStorage.getItem('emailVerified') === 'true';
      if (!emailVerified) navigate("/signup/email-verification", { replace: true });
    }
    if (step === 'user-info') {
      const emailVerified = sessionStorage.getItem('emailVerified') === 'true';
      const termsAgreed = sessionStorage.getItem('termsAgreed') === 'true';
      if (!emailVerified) navigate("/signup/email-verification", { replace: true });
      else if (!termsAgreed) navigate("/signup/terms", { replace: true });
    }
  }, [step, navigate]);

  return (
    <DefaultLayout
      headerType="sub"
      onBack={handleBack}>
      {step === 'email-verification' && (
        <EmailAuthStep
          emailAuth={emailAuth}
          setEmailAuth={setEmailAuth}
          setUserInfo={setUserInfo}
          onNext={() => handleNext('email-verification')}/>)}
      {step === 'terms' && (
        <TermsAgreeStep
          agreedTerms={agreedTerms}
          setAgreedTerms={setAgreedTerms}
          onNext={() => handleNext('terms')}/>)}
      {step === 'user-info' && 
        (<UserInfoStep
          userInfo={userInfo}
          setUserInfo={setUserInfo}
          tos={agreedTerms.has(3) ? 1 : 0}/>)}
      {isOpen && modalType === 'exit' && (
        <ExitModal
          title="회원가입을 종료할까요?"
          onClose={close}
          onConfirm={handleExit}/>
      )}
    </DefaultLayout>
  )
}

export default Signup
